import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import OrnamentalDivider from "@/components/OrnamentalDivider";

export default function PaymentCancel() {
  return (
    <div className="max-w-2xl mx-auto px-6 py-24 text-center" data-testid="payment-cancel">
      <XCircle size={56} className="mx-auto text-[#6E2638]" />
      <div className="serif text-5xl text-[#6E2638] mt-6">Payment cancelled.</div>
      <OrnamentalDivider label="No worries" />
      <p className="text-[#1A1817]/80">
        Your seat wasn't reserved. You can try again — or drop Martin an email if something's not working.
      </p>
      <div className="flex justify-center gap-4 mt-8">
        <Link to="/individual" className="btn-primary" data-testid="cancel-retry">Try again</Link>
        <Link to="/contact" className="btn-outline-gold" data-testid="cancel-contact">Contact Martin</Link>
      </div>
    </div>
  );
}
